import React, {useState} from "react"
import * as styles from './styles.module.scss';
import {Form} from "./blocks/Form"
import cls from "classnames"
import {FormProps} from "./types"
import {IdHeading} from "components/organisms/IdHeading";
import { InputClassNames } from "../Controls/Input";

type Props = {
    background?: {
        desktop: string
        tablet: string
        phone: string
    }
    details?: string
    title?: string
    description?: string
    headingLevel?: 1|2|3|4|5|6

    successDetails?: string
    successTitle?: string

    form: FormProps

    classNames?: {
        input?: InputClassNames
    }
}

export const ContactsForm = ({
                                 title,
                                 details,
                                 description,
                                 successDetails,
                                 successTitle,
                                 headingLevel = 2,
                                 background,
                                 form,
                                 classNames
                             }: Props) => {
    const [isSuccess, setIsSuccess] = useState(false);

    const onSubmit = () => {
        setIsSuccess(true);
        if (form?.additionalActions) {
            form?.additionalActions();
        };
    }

    return (
        <div className={styles.wrapper} id={"contacts-form-wrapper"}>
            {background && <picture>
                <source srcSet={background.desktop} media="(min-width: 1024px)"/>
                <source srcSet={background.tablet} media="(min-width: 768px)"/>
                <source srcSet={background.phone} media="(min-width: 1px)"/>
                <img className={cls(styles.background)}
                     decoding="async" loading="lazy"/>
            </picture>}

            <div className="bs-flex-container">
                <div className={styles.content}>
                    {isSuccess ?
                        <>
                            <p className={styles.details}>{successDetails}</p>
                            <IdHeading headingLevel={headingLevel} className={styles.title}>{successTitle}</IdHeading>
                            {description && <p className={styles.description}>{description}</p>}
                        </> :
                        <>
                            <p className={styles.details}>{details}</p>
                            <IdHeading headingLevel={headingLevel} className={styles.title}>{title}</IdHeading>
                            {description && <p className={styles.description}>{description}</p>}

                            <Form form={form} onSubmit={onSubmit}
                                classNames={{
                                    input: {
                                        container: classNames?.input?.container
                                    }
                                }}
                            />
                        </>
                    }
                </div>
            </div>
        </div>
    )
}
